import EventEmitter from 'eventemitter2'

const eventEmitter = new EventEmitter()
eventEmitter.setMaxListeners(200)

export default eventEmitter
